import imgMarcaPujCaliCmykNegroLatera11 from '../../assets/experience/logoPUJ.png';
import imgUpworkLogo from '../../assets/experience/logo-upwork.png';
import imgMarcaPujCaliCmykNegroLatera11Dark from '../../assets/experience/logoPUJDark.png';
import imgUpworkLogoDark from '../../assets/experience/logo-upworkDark.png';
import { translations } from '../i18n/translations';

// Datos base sin traducciones (solo refs y config)
export const experienceDataBase = [
  {
    id: 1,
    key: 'pujPCB',
    logoLight: imgMarcaPujCaliCmykNegroLatera11,
    logoDark: imgMarcaPujCaliCmykNegroLatera11Dark,
    period: 'Oct 2025 - Actual',
  },
  {
    id: 2,
    key: 'upworkEmbedded',
    logoLight: imgUpworkLogo,
    logoDark: imgUpworkLogoDark,
    period: 'May 2025 - Oct 2025',
  },
  {
    id: 3,
    key: 'pujSoftware',
    logoLight: imgMarcaPujCaliCmykNegroLatera11,
    logoDark: imgMarcaPujCaliCmykNegroLatera11Dark,
    period: 'Ene 2025 - Oct 2025',
  },
  {
    id: 4,
    key: 'pujElectronics',
    logoLight: imgMarcaPujCaliCmykNegroLatera11,
    logoDark: imgMarcaPujCaliCmykNegroLatera11Dark,
    period: 'Ene 2024 - Dic 2024',
  },
];

/**
 * Obtiene las experiencias con textos traducidos y logo correspondiente al tema
 * @param {string} language - 'es' o 'en'
 * @param {string} theme - 'light' o 'dark'
 * @returns {Array} Array de experiencias con posiciones, descripciones y logo traducidos
 */
export const getExperiencesWithTranslations = (language = 'es', theme = 'light') => {
  return experienceDataBase.map(exp => {
    const translatedData = translations[language].experienceData[exp.key];
    const logo = theme === 'dark' ? exp.logoDark : exp.logoLight;
    return {
      ...exp,
      logo,
      position: translatedData.position,
      company: translatedData.company,
      items: [
        translatedData.item1,
        translatedData.item2,
        translatedData.item3,
        ...(translatedData.item4 ? [translatedData.item4] : [])
      ]
    };
  });
};

/**
 * Obtiene experiencias específicas por sus IDs con traducciones
 * @param {Array<number>} ids - Array de IDs de experiencias a obtener
 * @param {string} language - 'es' o 'en'
 * @param {string} theme - 'light' o 'dark'
 * @returns {Array} Array de experiencias seleccionadas con traducciones
 */
export const getExperiencesByIds = (ids = [1, 2, 3, 4], language = 'es', theme = 'light') => {
  const experiencesWithTranslations = getExperiencesWithTranslations(language, theme);
  return experiencesWithTranslations.filter(exp => ids.includes(exp.id));
};
